import type { FaireProductEntity } from "../../entity_types/product";

export const p_63zv3rewye: FaireProductEntity = {
  token: "p_63zv3rewye",
  type: "product",
  name: "Juniper Large Red Wine Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/9ddba6d2f673bd17ec0fb0667e5d2823854886c5a34da9817a1e90b20aed312f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a51942364731e7828af56aa7f575813efe7144d4d0914601a2fd6f579ca355c.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Large Red Wine Glass\n• Dimension: Ø 10.6cm x H 23cm / Ø 4.2" x H 9"\n• Capacity: 500ml / 17 fl oz\n\n• Packed as a set of 2\n\n• Colour: clear\n\nPerfect addition to Autumn / Fall / Christmas / Holiday / Thanksgiving season collection!',
  tags: [],
  msrpDollars: 52.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:21.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
